<template>
  <global-layout>
    <contextmenu :itemList="menuItemList" :visible.sync="menuVisible" @select="onMenuSelect"/>
    <a-tabs
      class="page-tabs"
      @contextmenu.native="e => onContextmenu(e)"
      v-if="multipage"
      :active-key="activePage"
      style="margin-top: -8px; margin-bottom: 8px"
      :hide-add="true"
      type="editable-card"
      @change="changePage"
      @edit="editPage">
      <a-tab-pane :id="page.fullPath" :key="page.fullPath" v-for="page in pageList" :closable="!isPinned(page)" forceRender>
        <span slot="tab" :pagekey="page.fullPath">{{page.name}}</span>
      </a-tab-pane>
    </a-tabs>
      <keep-alive v-if="multipage">
        <router-view/>
      </keep-alive>
      <router-view v-else/>
  </global-layout>
</template>

<script>
import GlobalLayout from './GlobalLayout'
import Contextmenu from '~/menu/Contextmenu'

export default {
  name: 'MenuView',
  components: {Contextmenu, GlobalLayout},
  data () {
    return {
      pageList: [],
      linkList: [],
      activePage: '',
      menuVisible: false,
      menuItemList: [
        {key: '1', icon: 'arrow-left', text: '关闭左侧'},
        {key: '2', icon: 'arrow-right', text: '关闭右侧'},
        {key: '3', icon: 'close', text: '关闭其它'}
      ]
    }
  },
  computed: {
    multipage () {
      return this.$store.state.setting.multipage
    }
  },
  created () {
    this.resetPages()
    this.activePage = this.$route.fullPath
  },
  watch: {
    '$route': function (newRoute, oldRoute) {
      this.activePage = newRoute.fullPath
      if (!this.multipage) {
        this.linkList = [newRoute.fullPath]
        this.pageList = [newRoute]
      } else if (this.linkList.indexOf(newRoute.fullPath) < 0) {
        this.linkList.push(newRoute.fullPath)
        this.pageList.push(newRoute)
      }
    },
    'activePage': function (key) {
      if (key !== this.$route.fullPath) this.$router.push(key)
    },
    'multipage': function (newVal, oldVal) {
      if (!newVal) {
        this.linkList = [this.$route.fullPath]
        this.pageList = [this.$route]
      } else {
        this.resetPages()
      }
    }
  },
  methods: {
    isPinned (page) {
      return page.path === '/home' || (page.meta && page.meta.closeable === false)
    },

    resetPages () {
      const home = this.$router.resolve('/home').route
      this.pageList = this.multipage ? [home] : []

      if (!this.pageList.some(page => page.fullPath === this.$route.fullPath)) {
        this.pageList.push(this.$route)
      }

      this.linkList = this.pageList.map(page => page.fullPath)
    },

    changePage (key) {
      this.activePage = key
    },

    editPage (key, action) {
      this[action](key)
    },

    // 仅在需要切换页面时修改路由
    switchToPage (key) {
      if (!key || key === this.$route.fullPath) {
        this.activePage = this.$route.fullPath
        return
      }

      this.activePage = key
    },

    // 关闭单个标签
    remove (key) {
      const index = this.linkList.indexOf(key)
      const page = this.pageList.find(item => item.fullPath === key)

      if (index < 0 || !page || this.isPinned(page)) {
        return
      }

      const currentRoute = this.$route.fullPath
      const isClosingCurrent = key === currentRoute

      this.pageList = this.pageList.filter(item => item.fullPath !== key)
      this.linkList = this.pageList.map(item => item.fullPath)

      // 关闭的不是当前页面，只移除标签，不改变路由
      if (!isClosingCurrent) {
        this.activePage = currentRoute
        return
      }

      // 关闭当前页面，优先切换到原位置的下一个标签
      const nextIndex = Math.min(index, this.linkList.length - 1)
      const nextPage = this.linkList[nextIndex]

      if (nextPage) {
        this.switchToPage(nextPage)
      }
    },

    onContextmenu (e) {
      const pagekey = this.getPageKey(e.target)

      if (pagekey !== null) {
        e.preventDefault()
        this.menuVisible = true
      }
    },

    getPageKey (target, depth) {
      depth = depth || 0

      if (!target || depth > 2) {
        return null
      }

      let pageKey = target.getAttribute('pagekey')

      pageKey = pageKey || (
        target.previousElementSibling
          ? target.previousElementSibling.getAttribute('pagekey')
          : null
      )

      return pageKey || (
        target.firstElementChild
          ? this.getPageKey(target.firstElementChild, depth + 1)
          : null
      )
    },

    onMenuSelect (key, target) {
      const pageKey = this.getPageKey(target)

      switch (key) {
        case 0:
          this.closeLeft(pageKey)
          break
        case 1:
          this.closeRight(pageKey)
          break
        case 2:
          this.closeOthers(pageKey)
          break
        default:
          break
      }
    },

    // 关闭其他标签
    closeOthers (pageKey) {
      const index = this.linkList.indexOf(pageKey)

      if (index < 0) {
        return
      }

      const currentRoute = this.$route.fullPath

      this.pageList = this.pageList.filter(page => {
        return this.isPinned(page) || page.fullPath === pageKey
      })
      this.linkList = this.pageList.map(page => page.fullPath)

      // 当前路由仍保留，不进行跳转
      if (this.linkList.includes(currentRoute)) {
        this.activePage = currentRoute
        return
      }

      // 当前路由已被关闭，切换到右键选中的标签
      this.switchToPage(
        this.linkList.includes(pageKey) ? pageKey : this.linkList[0]
      )
    },

    // 关闭左侧标签
    closeLeft (pageKey) {
      const index = this.linkList.indexOf(pageKey)

      if (index < 0) {
        return
      }

      const currentRoute = this.$route.fullPath

      this.pageList = this.pageList.filter(page => {
        const pageIndex = this.linkList.indexOf(page.fullPath)
        return this.isPinned(page) || pageIndex >= index
      })
      this.linkList = this.pageList.map(page => page.fullPath)

      // 当前路由还存在，不改变路由
      if (this.linkList.includes(currentRoute)) {
        this.activePage = currentRoute
        return
      }

      this.switchToPage(this.linkList[0])
    },

    // 关闭右侧标签
    closeRight (pageKey) {
      const index = this.linkList.indexOf(pageKey)

      if (index < 0) {
        return
      }

      const currentRoute = this.$route.fullPath

      this.pageList = this.pageList.filter(page => {
        const pageIndex = this.linkList.indexOf(page.fullPath)
        return this.isPinned(page) || pageIndex <= index
      })
      this.linkList = this.pageList.map(page => page.fullPath)

      // 当前路由还存在，不改变路由
      if (this.linkList.includes(currentRoute)) {
        this.activePage = currentRoute
        return
      }

      this.switchToPage(this.linkList[this.linkList.length - 1])
    }
  }
}
</script>

<style scoped>
  >>>.ant-tabs-tab{
    margin-right: 1px !important;
  }
</style>
